function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import { Button, Row, Col } from 'antd';
import client from '../../feathers';
import JSONEditorReact from '../../json-editor';
import { ConsoleWrapper, EditorWrapper } from './index.style'; // import './JSONDisplay.less';

var schema = {
  $schema: 'http://json-schema.org/schema#',
  title: 'Default',
  type: 'object',
  properties: {
    clusterName: {
      type: 'string',
      enum: ['CryptoCompare', 'CoinMarketCap']
    },
    clusterType: {
      type: 'string'
    },
    clusterCategory: {
      type: 'string'
    },
    symbol: {
      type: 'string'
    },
    name: {
      type: 'string'
    },
    _limit: {
      type: 'number',
      title: '_limit',
      description: '_limit will return only the number of results you specify.',
      examples: [10, 15, 100]
    },
    _path: {
      type: 'string',
      title: '_path',
      description: '_path will query specific fields in a response using [JMESPath](https://jmespath.org/) query syntax.',
      examples: ['[].coins']
    },
    _fields: {
      type: 'string',
      title: '_fields',
      description: '_fields will return only the fields (or column names) you specify.',
      examples: ['hashrate,hashrate_auto']
    },
    _formatDates: {
      type: 'string',
      title: '_formatDates',
      description: '_formatDates will attempt to format a date series based on momentjs formatting.',
      examples: ['MM DD YYYY']
    },
    _count: {
      type: 'string',
      title: '_count',
      description: '_count will return the count of rows per the specified column header.',
      examples: ['algo_name']
    },
    _orderBy: {
      type: 'string',
      title: '_orderBy',
      description: "_orderBy will order a column ascending or descending (prefixed with a '-')",
      examples: ['-reward_day_usd,coin_ticker']
    },
    _output: {
      type: 'string',
      title: '_output',
      description: '_output will take any response and morph it into the desired output. Examples include: flatten, csv, and 2dArray',
      examples: ['flatten']
    },
    _renameHeaders: {
      type: 'boolean',
      title: '_renameHeaders',
      description: '_renameHeaders will rename headers based on specified native to alias mappings.',
      examples: [true]
    },
    _distinct: {
      type: 'string',
      title: '_distinct',
      description: 'Creates a duplicate-free version of the data, using SameValueZero for equality comparisons, in which only the first occurrence of each element is kept. The order of result values is determined by the order they occur in the initial data.',
      examples: ['-reward_day_usd,coin_ticker']
    }
  }
};
var autocomplete = {
  applyTo: ['value'],
  filter: 'contain',
  trigger: 'focus',

  getOptions(text, path, input, editor) {
    return ['option1', 'option2', 'option3', 'option4'];
  }

};
var json = {
  provider: 'CryptUnit',
  endpoint: 'Earnings Auto'
};
var templates = [{
  text: 'Default',
  title: 'Default',
  field: 'Default',
  value: {
    provider: 'CryptUnit',
    endpoint: 'Earnings Auto'
  }
}, {
  text: 'CryptoCompare - V2 Histoday',
  title: 'CryptoCompare - V2 Histoday',
  field: 'CryptoCompare - V2 Histoday',
  value: {
    provider: 'CryptoCompare',
    endpoint: 'V2 Histoday',
    fsym: 'BTC',
    tsym: 'USD'
  }
}, {
  text: 'Get BTC closing Price from Messari',
  title: 'Get BTC closing Price from Messari',
  field: 'Get BTC closing Price from Messari',
  value: {
    provider: 'Messari',
    endpoint: 'Get Asset Timeseries',
    assetKey: 'btc',
    metricID: 'price',
    start: '2020-01-01',
    end: '2020-02-01',
    interval: '1d',
    columns: 'close',
    _limit: 1,
    _fields: '1',
    _showHeaders: false
  }
}, {
  text: 'Global Parameters',
  title: 'Insert all Global Parameters',
  field: 'GlobalParametersTemplate',
  value: {
    _limit: 'testvalue',
    _path: 'testvalue',
    _fields: 'testvalue',
    _formatDates: 'testvalue',
    _count: 'testvalue',
    _orderBy: 'testvalue',
    _output: 'testvalue',
    _renameHeaders: 'testvalue',
    _distinct: 'testvalue'
  }
}, {
  text: '10%+ yields with no masternode requirement',
  title: '10%+ yields with no masternode requirement',
  field: '10%+ yields with no masternode requirement',
  value: {
    required_units_for_masternode: null,
    yearly_reward_percent: '10:',
    _limit: 14,
    _fields: '',
    _orderBy: ''
  }
}];
var modes = ['tree', 'form', 'view', 'code', 'text'];
var chooseTemplates = templates.map(template => template.text);

class App extends Component {
  constructor() {
    var _this;

    super(...arguments);
    _this = this;

    _defineProperty(this, "state", {
      schema,
      text: JSON.stringify(json, null, 2),
      mode: 'tree',
      template: 'Clusters',
      response: null
    });

    _defineProperty(this, "onRequest", /*#__PURE__*/_asyncToGenerator(function* () {
      var query = JSON.parse(_this.state.text);
      yield client.reAuthenticate();
      var response = yield client.service('api/query').find({
        query
      });

      _this.setState({
        response: JSON.stringify(response, null, 2)
      });
    }));

    _defineProperty(this, "onChangeText", text => {
      this.setState({
        text
      });
    });

    _defineProperty(this, "onModeChangeSelect", event => {
      this.setState({
        mode: event.target.value
      });
    });

    _defineProperty(this, "onModeChange", mode => {
      this.setState({
        mode
      });
    });

    _defineProperty(this, "onTemplateChange", template => {
      this.setState({
        template
      });
    });

    _defineProperty(this, "onTemplateChangeSelect", event => {
      console.log(event.target.value);
      var text = templates.find(template => template.text === event.target.value).value;
      console.log(text);
      this.setState({
        text: JSON.stringify(text, null, 2),
        template: event.target.value
      });
    });
  }

  render() {
    return /*#__PURE__*/React.createElement(ConsoleWrapper, {
      className: this.props.className
    }, /*#__PURE__*/React.createElement("h1", null, "JSONEditor React advanced demo"), /*#__PURE__*/React.createElement("div", {
      className: "contents"
    }, /*#__PURE__*/React.createElement("div", {
      className: "mode"
    }, "Scenario:", ' ', /*#__PURE__*/React.createElement("select", {
      value: this.state.template,
      onChange: this.onTemplateChangeSelect
    }, chooseTemplates.map(template => /*#__PURE__*/React.createElement("option", {
      key: template,
      value: template
    }, template)))), /*#__PURE__*/React.createElement(Row, {
      justify: "space-around",
      align: "middle",
      gutter: [16, 8]
    }, /*#__PURE__*/React.createElement(Col, {
      xs: {
        span: 24
      },
      lg: {
        span: 11
      }
    }, /*#__PURE__*/React.createElement(EditorWrapper, null, /*#__PURE__*/React.createElement(JSONEditorReact, {
      autocomplete: autocomplete,
      schema: this.state.schema,
      text: this.state.text,
      mode: this.state.mode,
      modes: modes,
      indentation: 4,
      onChangeText: this.onChangeText,
      onModeChange: this.onModeChange,
      templates: templates
    }))), /*#__PURE__*/React.createElement(Col, {
      xs: {
        span: 24
      },
      lg: {
        span: 2
      }
    }, /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.onRequest(),
      type: "primary",
      block: true
    }, "Make Request")), /*#__PURE__*/React.createElement(Col, {
      xs: {
        span: 24
      },
      lg: {
        span: 11
      }
    }, /*#__PURE__*/React.createElement(EditorWrapper, null, /*#__PURE__*/React.createElement(JSONEditorReact, {
      text: this.state.response,
      mode: this.state.mode,
      modes: modes,
      indentation: 4 // onChangeText={this.onChangeText}
      ,
      onModeChange: this.onModeChange
    }))))));
  }

}

export default App;